import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1488710606213736';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq queue (Meta Pixel base code, adapted for sandboxed envs)
    const f: any = window;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments as any) : n.queue.push(arguments);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject script safely — append to head/body directly instead of relying
    // on an existing <script> tag (which doesn't exist in some sandboxed envs)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.getElementsByTagName('script')[0]?.parentNode;
    if (target) {
      target.appendChild(script);
    }
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-206">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-207" />
    </noscript>;
}
export function trackAddToCart(data: {
  value?: number;
  currency?: string;
  content_name?: string;
  content_ids?: string[];
} = {}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'AddToCart', {
    value: data.value ?? 9.99,
    currency: data.currency ?? 'USD',
    content_name: data.content_name ?? 'Sistema de Reprogramación Interna de 30 Días',
    content_ids: data.content_ids ?? ['sistema-reprogramacion-30d'],
    content_type: 'product'
  });
}